import { render, staticRenderFns } from "./SurveyBig.vue?vue&type=template&id=12627400"
import script from "./SurveyBig.vue?vue&type=script&lang=js"
export * from "./SurveyBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports